import { IAuthService } from './auth.interface';
import { CognitoAuthService } from '../shared/services/cognito-auth.service';
import { KeycloakAuthService } from '../shared/services/keycloak-auth.service';
import { environment } from 'src/environments/environment';

/**
 * Factory function that selects the correct IAuthService implementation at
 * runtime based on `environment.authProvider`.
 *
 * Registered in AppModule providers:
 *   { provide: AUTH_SERVICE, useFactory: authServiceFactory, deps: [CognitoAuthService, KeycloakAuthService] }
 */
export function authServiceFactory(
  cognitoAuthService: CognitoAuthService,
  keycloakAuthService: KeycloakAuthService
): IAuthService {
  return environment.authProvider === 'keycloak' ? keycloakAuthService : cognitoAuthService;
}

/**
 * APP_INITIALIZER factory — calls `initialize()` on the resolved IAuthService.
 * For Cognito this is a no-op; for Keycloak it bootstraps the SDK and performs
 * a silent SSO check before the first route is activated.
 */
export function initializeAuthService(authService: IAuthService): () => Promise<boolean> {
  return () => authService.initialize();
}
